/* SAVID customer video cards.
 *
 * The poster and the <video> live inside the same card, so a click can
 * only ever start the video that belongs to that poster. Playback is
 * exclusive: starting one card stops any other that is playing.
 */
(function () {
  var cards = document.querySelectorAll('[data-savid-vcard]');
  if (!cards.length) return;

  function stopAll(except) {
    Array.prototype.forEach.call(cards, function (card) {
      if (card === except) return;
      var v = card.querySelector('[data-savid-vplayer]');
      if (v && !v.paused) v.pause();
      card.classList.remove('is-playing');
    });
  }

  Array.prototype.forEach.call(cards, function (card) {
    var btn = card.querySelector('[data-savid-vplay]');
    var video = card.querySelector('[data-savid-vplayer]');
    if (!btn || !video) return;

    btn.addEventListener('click', function (ev) {
      /* once the native controls are showing, let them have the clicks */
      if (card.classList.contains('is-playing')) return;
      ev.preventDefault();
      stopAll(card);
      card.classList.add('is-playing');
      video.preload = 'auto';
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { card.classList.remove('is-playing'); });
      }
    });

    video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
  });
})();
